import {
  DeviceUUID
} from "device-uuid/lib/device-uuid";

export function getDeviceUuid() {
  const du = new DeviceUUID().parse();
  const EMAIL = localStorage.getItem("email");
  if (EMAIL != null || EMAIL != "") {
    var dua = [
      du.language,
      du.colorDepth,
      du.platform,
      du.os,
      du.cpuCores,
      du.isAuthoritative,
      du.silkAccelerated,
      du.isKindleFire,
      du.isDesktop,
      du.isMobile,
      du.isTablet,
      du.isWindows,
      du.isLinux,
      du.isLinux64,
      du.isChromeOS,
      du.isMac,
      du.isiPad,
      du.isiPhone,
      du.isiPod,
      du.isSmartTV,
      du.pixelDepth,
      du.isTouchScreen,
      EMAIL
    ]
    const uuid = du.hashMD5(dua.join(':'));
    return uuid;
  } else {
    return false
  }
}